import Decision from "../Components/Decision";
import Header from "../Components/Header";
import Banner from "../Components/Banner";
import EventOverlay from "../Components/EventOverlay";
import Footer from "../Components/Footer";
import Events from "./Events";
import { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import { ActiveEvents } from "../Recoil/ActiveEvents";
import { Link } from "react-router-dom";

export default function Home() {
    const [currentEventData, setCurrentEventData] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const activeEvents = useRecoilValue(ActiveEvents);
    
    useEffect(() => {
      if (activeEvents && activeEvents.length > 0) {
        setCurrentEventData(activeEvents[currentIndex] || activeEvents[0]);
      }
    }, [activeEvents, currentIndex]);

    const handleSlideChange = (index) => {
      setCurrentIndex(index);
    };

    return (
      <div>
        <Header />
        <EventOverlay eventData={currentEventData} />
        <Banner onSlideChange={handleSlideChange} />
        {/* <OurStory /> */}
        <Events />
        <Decision/>
        <Footer />
      </div>
    );
  }